/* the default transformation function */
export function transformChartData({ apiData, selectedMetrics }) {
  const chartData = [];
  const defaultBgColor = "";

  const labels = apiData.x_axis;

  selectedMetrics.forEach((selectedMetric, index) => {
    const metricType = selectedMetric.metricType;

    if (metricType === "revenue") {
      chartData.push({
        data: apiData.y_axis,
        backgroundColor: selectedMetric.backgroundColor,
        borderColor: selectedMetric.borderColor,
        fill: selectedMetric.fill,
      });
    } else if (metricType === "referrals") {
      if (index === 0) {
        chartData.push({
          data: apiData.y_axis,
          backgroundColor: selectedMetric.backgroundColor,
          borderColor: selectedMetric.borderColor,
          fill: selectedMetric.fill,
        });
      } else if (index === 1 && apiData.y1_axis && apiData.y1_axis.length > 0) {
        chartData.push({
          data: apiData.y1_axis,
          backgroundColor: selectedMetric.backgroundColor,
          borderColor: selectedMetric.borderColor,
          fill: selectedMetric.fill,
        });
      }
    }
  });

  return [chartData, labels];
}
